import config from "../../../config";
import sendRequest from "../../../helpers/requestHelper";
import {handleError} from "../../../helpers/handleError";
import eventBus from "../../../event-bus/eventBus";

const deleteClient = {
    namespaced: true,
    state: {
        isShowDeleteModal: false,
        isLoadingDeleteModal: false,
        isShowDeleteModalInfo: false,
        modalDeleteInfoData: {},
        modalDeleteData: {}
    },
    mutations: {
        DELETE_CLIENT_SUCCESS(state, deleteData) {
            state.modalDeleteInfoData.typeInfo = "green";
            state.modalDeleteInfoData.head = deleteData.result.data.message;
            state.modalDeleteInfoData.textInfo = deleteData.result.data.data.textInfo;
            state.isShowDeleteModalInfo = true;
            eventBus.$emit("deleteItemSelect", deleteData.id, deleteData.result.data.data.isInvoiceGenerated);
        },
        DELETE_CLIENT_FAILURE(state , error) {
            state.modalDeleteInfoData.typeInfo = "red";
            state.modalDeleteInfoData.head = error.response.data.message;
            state.modalDeleteInfoData.textInfo = handleError(error) !== "" ? handleError(error) : error.response.data.data.message;
        },
        SHOW_MODAL_DELETE_DATA(state, modalDeleteData) {
            state.modalDeleteData.typeInfo = "primary";
            state.modalDeleteData.head = modalDeleteData.languageData.head;
            state.modalDeleteData.btnAgreeText = modalDeleteData.languageData.btnAgreeText;
            state.modalDeleteData.textInfo = modalDeleteData.languageData.textInfo + modalDeleteData.name;
            state.modalDeleteData.idData = modalDeleteData.id;
            state.modalDeleteData.index = modalDeleteData.index;
            state.isShowDeleteModal = true;
        },
        HIDE_MODAL_DELETE_ACTION(state, value) {
            state.isShowDeleteModal = value;
        },
        HIDE_MODAL_DELETE_INFO_ACTION(state, value) {
            state.isShowDeleteModalInfo = value;
        }
    },
    actions: {
        showDeleteModal( { state } ) {
            state.isShowDeleteModal = true;
        },
        deleteClientRequest( { dispatch, state }, value) {
            state.isLoadingDeleteModal = true;
            var promise = sendRequest("delete", config.baseURLApi+"/clients/"+value, {});
            promise.then(function(result) {
                if(result[0] === "success") {
                    var deleteData = {};
                    deleteData.result = result[1];
                    deleteData.id = value;
                    dispatch("successDeleteClient", deleteData);
                } else {
                    dispatch("failureDeleteClient", result[1]);
                }
                state.isLoadingDeleteModal = false;
                state.isShowDeleteModal = false;
            });
        },
        successDeleteClient({ commit }, response) {
            commit("DELETE_CLIENT_SUCCESS", response);
        },
        failureDeleteClient({ commit }, error) {
            commit("DELETE_CLIENT_FAILURE", error);
        },
        showModalDeleteData({ commit }, modalDeleteData) {
            commit("SHOW_MODAL_DELETE_DATA", modalDeleteData);
        },
        hideModalDeleteAction({ commit }) {
            commit("HIDE_MODAL_DELETE_ACTION", false);
        },
        hideModalDeleteInfoAction({ commit }) {
            commit("HIDE_MODAL_DELETE_INFO_ACTION", false);
        }
    }
}

export default deleteClient;